import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Link } from '@/components/ui/link'
import { Skeleton } from '@/components/ui/skeleton'
import { HStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import { getAttachement } from '@/store/tasksApprovals/detailsDrawer'
import { IApprovalDetail, IAttachments, ITaskDetail, TIntegratedSystems, TMainSections } from '@/types/tasksApprovals'

const Attachements = ({
    item,
    systemID,
    itemID,
    type,
}: {
    item: IApprovalDetail | ITaskDetail | null
    systemID: TIntegratedSystems
    itemID: string
    type: TMainSections
}) => {
    const { t } = useTranslation()
    const [isDownloading, setIsDownloading] = useState<{ [key: string]: boolean }>({})
    const [isDownloaded, setIsDownloaded] = useState<{ [key: string]: boolean }>({})

    if (!item?.attachments) {
        return null
    }

    const getAttachementFile = async (systemId: string, approvalId: string, fileName: string, attachementId?: string) => {
        if (attachementId) {
            setIsDownloading((prev) => {
                prev[attachementId] = true
                return { ...prev }
            })

            const response = await getAttachement(systemId, approvalId, attachementId, fileName, type)
            if (response) {
                setIsDownloading((prev) => {
                    prev[attachementId] = false
                    return { ...prev }
                })
                setIsDownloaded((prev) => {
                    prev[attachementId] = true
                    return { ...prev }
                })
            }
        }
    }

    const getDownloadLink = (systemId: string, approvalId: string, fileName: string, attachementId?: string) => {
        if (attachementId) {
            if (isDownloading[attachementId]) {
                return <Skeleton height="20px" width="40%" />
            }

            return (
                <Link
                    onClick={() => {
                        void getAttachementFile(systemId, approvalId, fileName, attachementId)
                    }}
                    isExternal
                    textDecor="underline"
                    fontSize="14px"
                    fontWeight="bold"
                >
                    {fileName}
                </Link>
            )
        }
    }
    return (
        item &&
        item.attachments.map((attachement: IAttachments, index: number) => {
            return (
                <Box key={index} pb="16px" px="24px">
                    <HStack justifyContent="space-between">
                        <Text fontSize="12px" pb="4px">
                            {t('tasksApprovals.drawer.attachement')}
                        </Text>
                        {attachement.attachment_id && isDownloaded[attachement.attachment_id] && (
                            <Text fontSize="12px" pb="4px" color=" var(--chakra-colors-status-success)">
                                {t('tasksApprovals.drawer.downloaded')}
                            </Text>
                        )}
                    </HStack>
                    {attachement.external_link ? (
                        <Link href={attachement.external_link} isExternal textDecor="underline" fontSize="14px" fontWeight="bold">
                            {attachement.file_name}
                        </Link>
                    ) : (
                        getDownloadLink(systemID, itemID, attachement.file_name, attachement.attachment_id)
                    )}
                </Box>
            )
        })
    )
}

export default Attachements
